'use strict';
namespace Core {

    interface IExtraFocusTrackerEventQueue {
        queue: ((JQuery) => void)[];
    }

    class ExtraFocusTracker {

        cssClass = _.uniqueId('extra-focus-tracker-');

        constructor(
            private $element,
            private $scope,
            private extraFocusTrackerEventQueue: IExtraFocusTrackerEventQueue
        ) {
            let func = target => {
                if (target.is('body, body *')) {
                    if (!target.is('a[href], a[href] *')) {
                        this.setFocus(target.is(`.${this.cssClass}, .${this.cssClass} *`));
                    }
                }
            };
            extraFocusTrackerEventQueue.queue.push(func);
            $scope.$on('$destroy', () => _.pull(extraFocusTrackerEventQueue.queue, func));
        }

        setFocus(value) {
            if (this.$scope.extraFocusTrackerFocused !== value) {
                this.$scope.$evalAsync(() => this.$scope.extraFocusTrackerFocused = value);
            }
        }
    }

    angular
        .module('core')
        .factory('extraFocusTrackerEventQueue', () => {
            const service: IExtraFocusTrackerEventQueue = {
                queue: []
            };
            $(() => {
                $('body').on('focusin click touchstart', '*', event => {
                    const target = $(event.target);
                    service.queue.forEach(f => f(target));
                });
            });
            return service;
        })
        .directive('extraFocusTracker', ($timeout): ng.IDirective => {
            return {
                controller: ExtraFocusTracker,
                restrict: 'A',
                link: (scope: any, element: JQuery, attrs, controller: ExtraFocusTracker) => {
                    element.addClass(controller.cssClass);
                    scope.extraFocusTrackerFocused = false;
                }
            };
        });
}
